import { render, staticRenderFns } from "./UiUploadFileDialog.vue?vue&type=template&id=c2b0ad1a&scoped=true&lang=pug"
import script from "./UiUploadFileDialog.vue?vue&type=script&lang=js"
export * from "./UiUploadFileDialog.vue?vue&type=script&lang=js"
import style0 from "./UiUploadFileDialog.vue?vue&type=style&index=0&id=c2b0ad1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2b0ad1a",
  null
  
)

export default component.exports